enum SortOrder {
	Asc = "asc",
	Desc = "desc",
}

export default SortOrder;
